"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityScopeForPage = void 0;
const entityScopeMapping_json_1 = __importDefault(require("../../routes/entityScopeMapping.json"));
/**
 * Returns the Entity scope for a specific page id.
 * @param page the page id
 */
function getEntityScopeForPage(page) {
    const scope = entityScopeMapping_json_1.default[page];
    if (!scope) {
        throw new Error(`Missing url path for page: ${page}`);
    }
    return scope;
}
exports.getEntityScopeForPage = getEntityScopeForPage;
//# sourceMappingURL=EndUserPageHelper.js.map